import React, { PropsWithChildren } from 'react';

type WorkersScreenProps = {};

export const WorkersScreen = ({
  children,
}: PropsWithChildren<WorkersScreenProps>) => {
  return <>{children}</>;
};
